import { ApplicationRef, Injectable } from '@angular/core';
import { concat, filter, first, interval } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

@Injectable()
export class AppUpdateService {

    public updateingNow = false;

    constructor(appRef: ApplicationRef, swUpdate: SwUpdate, private http: HttpClient) {
        // Allow the app to stabilize first, before starting
        // polling for updates with `interval()`.
        const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
        const every30mins$ = interval(30 * 60 * 1000);
        const every30MinsOnceAppIsStable$ = concat(appIsStable$, every30mins$);

        every30MinsOnceAppIsStable$.subscribe(async () => {
          try {
            const updateFound = await swUpdate.checkForUpdate();
          } catch (err) {
          }
        });

        swUpdate.versionUpdates
            .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe(evt => {
              swUpdate.activateUpdate().then(() => {});
            });

    }

}
